import { render, staticRenderFns } from "./make_doc_title.vue?vue&type=template&id=55c38dfa&scoped=true&"
import script from "./make_doc_title.vue?vue&type=script&lang=js&"
export * from "./make_doc_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c38dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c38dfa')) {
      api.createRecord('55c38dfa', component.options)
    } else {
      api.reload('55c38dfa', component.options)
    }
    module.hot.accept("./make_doc_title.vue?vue&type=template&id=55c38dfa&scoped=true&", function () {
      api.rerender('55c38dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/helpers/make_doc_title.vue"
export default component.exports